import { $regex as __regex, createQueryOperator } from "../../_predicates";
const $regex = createQueryOperator(__regex);
export {
  $regex
};
